import React, { useEffect } from 'react';

const UpdateScreen = ({ versionStatus, onSkip, recheckVersion }) => {
  // Listen for app coming back from background after update
  useEffect(() => {
    if (!versionStatus || !recheckVersion) return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        console.log('🔄 UpdateScreen: App focused - rechecking version...');
        recheckVersion();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [versionStatus, recheckVersion]);

  if (!versionStatus) return null;
  const { update_mode, message, store_url } = versionStatus;

  if (['force', 'blocked', 'maintenance'].includes(update_mode)) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '24px', textAlign: 'center'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>
          {update_mode === 'maintenance' ? '🔧' : update_mode === 'blocked' ? '📡' : '🔄'}
        </div>
        <h1 style={{ color: 'white', fontSize: '1.5rem', marginBottom: '12px' }}>
          {update_mode === 'maintenance' ? 'Đang bảo trì' :
           update_mode === 'blocked' ? 'Không thể kết nối' : 'Cần cập nhật'}
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '32px', lineHeight: 1.6 }}>
          {message}
        </p>
        {store_url && update_mode === 'force' && (
          <button onClick={() => window.open(store_url, '_blank')} style={{
            background: 'white', color: '#764ba2', border: 'none',
            padding: '14px 32px', borderRadius: '25px',
            fontSize: '1rem', fontWeight: '700', cursor: 'pointer'
          }}>Cập nhật ngay</button>
        )}
        {update_mode === 'blocked' && (
          <button onClick={() => window.location.reload()} style={{
            background: 'white', color: '#764ba2', border: 'none',
            padding: '14px 32px', borderRadius: '25px',
            fontSize: '1rem', fontWeight: '700', cursor: 'pointer'
          }}>Thử lại</button>
        )}
      </div>
    );
  }

  if (update_mode === 'soft') {
    return (
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0,
        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        padding: '16px 20px', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', zIndex: 9999,
        boxShadow: '0 -4px 12px rgba(0,0,0,0.15)'
      }}>
        <div>
          <div style={{ color: 'white', fontWeight: '600', fontSize: '0.875rem' }}>
            🆕 Có phiên bản mới!
          </div>
          <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.75rem' }}>
            {message}
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {store_url && (
            <button onClick={() => window.open(store_url, '_blank')} style={{
              background: 'white', color: '#11998e', border: 'none',
              padding: '8px 16px', borderRadius: '20px',
              fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer'
            }}>Cập nhật</button>
          )}
          <button onClick={onSkip} style={{
            background: 'transparent', color: 'white',
            border: '1px solid rgba(255,255,255,0.5)',
            padding: '8px 12px', borderRadius: '20px',
            fontSize: '0.8rem', cursor: 'pointer'
          }}>Bỏ qua</button>
        </div>
      </div>
    );
  }

  return null;
};

export default UpdateScreen;
